import Player from '@vimeo/player';
export const initHero = () => {
    // Initialize HTML5 video controls
   

    // Initialize Vimeo video controls
   


    const initializeHtmlVideoPlayers = () => {
        const heroBlocks = document.querySelectorAll('.hero-block');

        heroBlocks.forEach((heroBlock) => {
            const playPauseButton = heroBlock.querySelector('.play-pause-button') as HTMLButtonElement;
            const video = heroBlock.querySelector('.picture-section__video') as HTMLVideoElement;

            if (playPauseButton && video) {
                playPauseButton.addEventListener('click', () => {
                    playPauseButton.classList.toggle('active');

                    if (video.paused) {
                        video.play();
                    } else {
                        video.pause();
                    }
                });
            }
        });
    }
    initializeHtmlVideoPlayers();
    const initializeHeroVimeoPlayer = () => {
        const iframes = document.querySelectorAll('[data-player]');

        iframes.forEach((iframe) => {
            const player = new Player(iframe as HTMLIFrameElement);
            const heroBlock = iframe.closest('[class*="hero"]');

            if (!heroBlock) return;

            const btn = heroBlock.querySelector('.play-pause-button') as HTMLButtonElement;
            const controlContainer = heroBlock.querySelector('[class*="controls"]');
            const playLabel = controlContainer?.getAttribute('data-playvideo');
            const pauseLabel = controlContainer?.getAttribute('data-pausevideo');

            if (!btn) return;

            btn.addEventListener('click', function () {
                btn.classList.toggle('active');
                player.getPaused().then(function (paused: boolean) {
                    if (paused) {
                        player.play();
                        btn.ariaLabel = pauseLabel || '';
                        btn.title = pauseLabel || '';
                    } else {
                        player.pause();
                        btn.ariaLabel = playLabel || '';
                        btn.title = playLabel || '';
                    }
                });
            });
        });
    }
    initializeHeroVimeoPlayer();
}